export default {
  error: 'Error',
  sorry: 'Sorry, we have received the following error',
  workingOnIt:
    'An engineer has been notified of this problem and we are working to resolve it as swiftly as possible.',
  tryAgain: 'Please try again later',
  noInternet:
    'There appears to be a problem with your internet connection. Please check and try again.',
}
